import React from 'react'
import {
  View,
} from 'react-native'
import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { theme, colors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'

import { stackNavigationProps } from '../nagivationProps'

import CallHistory from './CallHistory'

const Stack = createStackNavigator()

function CallHistoryStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='CallHistory'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="CallHistory"
        component={CallHistory}
        options={{
          title: "Call History",
          headerTitleStyle: theme.navigationHeader,
          headerShadowVisible: false,
          headerLeft: () => (<View style={{paddingLeft: 15}}>
            <CompanyIcon color={colors.srGreen} height={60} width={60} />
          </View>)
        }}
        
      />
    </Stack.Navigator>
  )
}

export default CallHistoryStackNavigator